import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../shared/components/';

export default class ViewBasketButton extends React.Component {
  /**
   * for mock purpose
   */
  static getWindow() {
    return window;
  }

  viewBasket() {
    ViewBasketButton.getWindow().location.assign(this.props.redirectUrl);
  }

  render() {
    return (
      <Button
        customClass={`nav-view-cart ${this.props.className}`}
        secondary
        large
        onClick={() => this.viewBasket()}
        label={this.props.label}
      />
    );
  }
}
ViewBasketButton.propTypes = {
  label: PropTypes.string,
  redirectUrl: PropTypes.string,
  className: PropTypes.string,
};

ViewBasketButton.defaultProps = {
  label: 'click me',
  redirectUrl: '',
  className: '',
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/ViewBasketButton/ViewBasketButton.js